import PopUpNotification from "../ui/pop-up-notification.ts";
import NotificationType from "../enums/notification-type.ts";

export default class LogUtils {
  /**
   * Logs a DEBUG-level message to the browser console.
   * @param debug If true, logs the debug message. If false, doesn't log it.
   * @param message The debug message to log.
   */
  public static debug(debug: boolean, message: string): void {
    // only log a debug message if the application is in debug mode
    if (!debug) {
      return;
    }

    // debug mode enabled
    console.debug(message);
  }

  /**
   * Logs a WARN-level message to the browser console.
   * @param debug If true, logs the warning message. If false, doesn't log it.
   * @param message The warning message to log.
   */
  public static warn(debug: boolean, message: string): void {
    // only log a debug message if the application is in debug mode
    if (!debug) {
      return;
    }

    // debug mode enabled
    console.warn(message);
  }

  /**
   * Logs an INFO-level message to the browser console.
   * @param message The info message to log.
   */
  public static info(message: string): void {
    new PopUpNotification(NotificationType.INFO, message);
    console.info(message);
  }

  /**
   * Logs an ERROR-level message to the browser console.
   * @param message The error message to log.
   * @param popUpMessage The message to display to the user as a pop-up notification. Defaults to "Unexpected error
   * occurred".
   */
  public static error(message: string, popUpMessage = "Unexpected error occurred"): never {
    new PopUpNotification(NotificationType.ERROR, popUpMessage);
    throw Error(message);
  }
}
